import React from 'react'
import Layout from '../Layout'
import DashboardHeader from '../DashboardHeader'
import CartComponent from '../../../utils/CommonFunctionality/Cart'
import SEOTAG from '../../../utils/CommonFunctionality/SEO/AllpagesSEO'

const Cart = (props) => {
    return (
        <>
            <SEOTAG page="Cart" />
            <Layout props={props}>
                {/* <DashboardHeader /> */}
                <div className="lq-db-table">
                    <CartComponent props={props} />
                </div>
            </Layout>
        </>
    )
}

export default Cart
